// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
// styles
import 'font-awesome/less/font-awesome.less';
import './History.less';

class HistoryFilters extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    togglePacerFilterSection: PropTypes.func,
    loadingSpinner: PropTypes.bool,
    showPacerFilterSection: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => null,
    togglePacerFilterSection: () => null,
    loadingSpinner: false,
    showPacerFilterSection: true,
  };

  render() {
    const {
      onSubmit,
      loadingSpinner,
    } = this.props;

    const show_docket = false;
    const history_type = 'History';
    return (
      <Form
      initialValues={{ show_docket, history_type }}
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        // pristine,
        // form,
        // reset,
        submitting,
        }) => (
          <div id="history-pacer-filter" className="inside-block">
            <form onSubmit={handleSubmit} id="history-pacer-form">
            <button type="submit" disabled={submitting} className="form-submit green" style={{float: 'right', marginTop: 45 }}>
                  {loadingSpinner ? <i className="fa fa-spinner fa-spin" /> : <div>Pacer Search</div>}
                </button>
              <div className="history-pacer-form-row">
                <label htmlFor="history_type">
                  <Field
                  name="history_type"
                  component="input"
                  type="radio"
                  value="History"
                />{' '}
                All events (history)
                </label>
                <label htmlFor="history_type">
                  <Field
                  name="history_type"
                  component="input"
                  type="radio"
                  value="Documents"
                />{' '}
                Only events with documents
                </label>
                <label htmlFor="show_docket">
                  <Field
                    name="show_docket"
                    component="input"
                    type="checkbox"
                  />{' '}
                  Retrieve docket text (may significantly increase PACER fee)
                </label>
              </div>
            </form>
          </div>)}
      />
    );
  }
}

export default HistoryFilters;



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryFilters.jsx